import { render, staticRenderFns } from "./ProtectedPage.vue?vue&type=template&id=9570517e&"
import script from "./ProtectedPage.vue?vue&type=script&lang=js&"
export * from "./ProtectedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports